import React from 'react';
import { Button, Form, FormGroup, Input } from 'reactstrap';

class OrganizationSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOrganizationId: "",
            searchInput: ""
        };
    }

    handleSearchChange = (event) => {
        this.setState({
            searchInput: event.target.value
        });
    }

    handleSelectOrganization = (orgId) => {
        this.setState({
            selectedOrganizationId: orgId
        });
    }

    handleFormSubmit = (formSubmitEvent) => {
        formSubmitEvent.preventDefault();
        this.props.onSubmit(this.state.selectedOrganizationId); 
    }

    getFilteredOrganizations = () => {
        const searchLower = this.state.searchInput.toLowerCase();
        return this.props.organizations.filter(org => 
            org.name.toLowerCase().includes(searchLower)
        );
    }
    
    // The list of organizations
    renderOrganizationList = (organizations) => {
        return organizations.map((org) => (
            <div 
                key={org.id} 
                className='d-flex align-items-center mb-2'
                style={{ 
                    borderBottom: '1px solid #ddd',
                    paddingBottom: '10px',
                    marginBottom: '10px',
                    backgroundColor: this.state.selectedOrganizationId === org.id ? '#e8f4f8' : '',
                    cursor: 'pointer'
                }}
                onClick={() => this.handleSelectOrganization(org.id)}
            >
                <span className='mr-2'>{org.connected ? "🟩 " : "🟨 "}{org.name}</span>
            </div>
        ));
    }
    
    // Returning the actual selected
    render() {
        const filteredOrganizations = this.getFilteredOrganizations();

        return (
            <Form onSubmit={this.handleFormSubmit}>
                <div className='mb-4 text-center large-rounded bg-white border-light-sf-orange p-4'>
                    <h4 className='mb-4'>Select an Operations Center Organization to connect to your Marksman Team</h4>
                    <FormGroup className='mb-3'>
                        <Input type="text" placeholder="Search for an organization..." value={this.state.searchInput} onChange={this.handleSearchChange} />
                    </FormGroup>
                    <div style={{ height: '400px', overflowY: 'auto' }}>
                        {this.renderOrganizationList(filteredOrganizations)}
                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <Button type="submit" disabled={this.state.selectedOrganizationId === ""}>Submit</Button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default OrganizationSelector;



// WEBPACK FOOTER //
// ./src/components/ui/OrganizationSelector.js